export const PAGE_LIFECYCLE_STATE_ENUM = {
  active: "active",
  passive: "passive",
  hidden: "hidden",
  frozen: "frozen",
  terminated: "terminated",
};
